// extracted by mini-css-extract-plugin
module.exports = {"button":"SaveButton_button__1AzqO","icon":"SaveButton_icon__37Emj"};